module.exports = __webpack_public_path__ + "img/logo-shiba888.c50a0ee5.png";